export enum ApplicationState {
  INITIALIZED = 'INITIALIZED',
  CONFIRMED = 'CONFIRMED',
  SIGNED = 'SIGNED',
  CREATED = 'CREATED',
  REJECTED = 'REJECTED',
  REVIEW = 'REVIEW',
  WAITING_FOR_BANK_GUARANTEE = 'WAITING_FOR_BANK_GUARANTEE',
}
